import React, { useMemo } from 'react';
import { FormBuilder } from 'new/components/settings/VendorBuilder/FormControlBuilder';

interface CertSignedFieldsProps {
  index: number;
}

const certFields = (index) => [
  {
    type: 'text',
    name: `auth_templates[${index}].config["client.p12"]`,
    label: (
      <>
        Client Certificate in P12 format <code>auth_templates[{index}].config["client.p12"]</code>
      </>
    ),
    description:
      'Enter the content of the P12-formatted certificate file that will be used to sign the API requests. The P12 file typically consists of the private key and certificate chain. You can open the file in any text editor and copy its content here.',
  },
  {
    type: 'text',
    name: `auth_templates[${index}].config["client.p12.passphrase"]`,
    label: (
      <>
        P12 PassPhrase <code>auth_templates[{index}].config["client.p12.passphrase"]</code>
      </>
    ),
    description:
      ' Enter the passphrase associated(if any) with the certificate file. API vendors often require an API secret to also be used for CertSigned signature authentication.',
  },
];

export const CertSignedFields = (props: CertSignedFieldsProps) => {
  const fields = useMemo(() => certFields(props.index), [props.index]);
  return <FormBuilder fields={fields} />;
};
